import React, { useState, useCallback, useEffect } from 'react';

import { Pagination, Skeleton } from 'antd';

import styles from './notifications.module.scss';
import '../../theme/global.scss';

import CCard from '../../components/card/card';
import CSearchBar from '../../components/search-bar/search_bar';
import Tabs from '../../components/vertical-tab/tabs';
import {
  TypeNotification,
  TYPES_NOTIFICATIONS,
  types_notifications
} from '../../types/menu-notifications';
import { Space } from '../../components/utils/utils';
import {
  computeDescriptionMessage,
  mapDetails,
  mapTypeToMessage
} from '../../utils/notifications';
import {
  downloadOneDecision,
  getNotifications,
  getPrincipalsNotifications
} from '../../network/notifications';
import CSorting from '../../components/sort/sort';
import { sort_chronologically } from '../../utils/lists';
import { variables } from '../../utils/variables';
import { prettyDate } from '../../utils/strings';

const Notifications = () => {
  const [filterValue, setValue] = useState('');
  const [notifications, setNotifications] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [currentPage, setPage] = useState(1);
  const [info, setInfo] = useState({
    totalRecords: 0
  });
  const [sortValue, setSort] = useState('');

  const currOption = types_notifications[3];

  const getNotificationsCallback = useCallback(() => {
    setLoading(true);
    getNotifications('litigation', currentPage, filterValue).then(data => {
      setNotifications(data);
      setInfo(data);
      setLoading(false);
    });
  }, [currentPage, filterValue]);

  const handleFilter = (event: React.ChangeEvent<any>) => {
    const { value } = event.target;
    setValue(value);
  };

  const handleSort = (key: string) => {
    console.log(sortValue);
    setSort(key);
  };

  /* watcher for tabs  */
  useEffect(() => {
    getNotificationsCallback();
  }, [getNotificationsCallback]);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className='justify-start'>
          <CSearchBar value={filterValue} onChange={handleFilter} />
          <Space horizontal={20} />
          {false && <CSorting value={filterValue} onChange={handleSort} />}
        </div>
        {/* {notifications && notifications.length === 0 && <Spin />} */}
        {notifications && (
          <p className='body-dark faded'>
            Aveți {notifications.totalRecords} notificări pentru litigii.
          </p>
        )}
        {loading && <Skeleton active />}
        {notifications && (
          <div className={styles.list}>
            {notifications.data.map((option: any) => (
              <CCard
                key={option.id}
                title={mapTypeToMessage(currOption, option)}
                date={
                  option.hasOwnProperty('notificationDate') &&
                  prettyDate(option.notificationDate)
                }
                description={
                  currOption.key === TYPES_NOTIFICATIONS.HOTARARI
                    ? 'Pentru mai multe informații descărcați documentul'
                    : option.hasOwnProperty('description') &&
                      computeDescriptionMessage(option.type, option.description)
                }
                downloadLink={
                  currOption.key === TYPES_NOTIFICATIONS.HOTARARI
                    ? () =>
                        downloadOneDecision(
                          option.id,
                          option.institutionId,
                          option.name
                        )
                    : null
                }
                details={mapDetails(
                  { key: 'litigations', name: 'Litigii' },
                  option
                )}
              />
            ))}
          </div>
        )}
        {info && (
          <div className='row center'>
            <Pagination
              defaultCurrent={1}
              total={info.totalRecords}
              current={currentPage}
              pageSize={variables.paginationRatio}
              onChange={e => setPage(e)}
            />
          </div>
        )}
        <Space vertical='3vh' />
      </div>
    </div>
  );
};

export default Notifications;
